import api from "../services/api";

/**
 * Request campaign logs download
 * @param {number} campaignId - Campaign ID
 * @returns {Promise} API response
 */
export const requestCampaignLogs = async (campaignId) => {
  return api.post("/api/download-center/request", { campaign_id: campaignId });
};

/**
 * Get all download tasks for user
 * @param {Object} filters - Filter options (status, limit, offset)
 * @returns {Promise} API response
 */
export const getDownloadTasks = async (filters = {}) => {
  return api.get("/api/download-center/tasks", { params: filters });
};

/**
 * Get single download task by ID
 * @param {number} taskId - Task ID
 * @returns {Promise} API response
 */
export const getDownloadTaskById = async (taskId) => {
  return api.get(`/api/download-center/tasks/${taskId}`);
};

/**
 * Delete download task
 * @param {number} taskId - Task ID
 * @returns {Promise} API response
 */
export const deleteDownloadTask = async (taskId) => {
  return api.delete(`/api/download-center/tasks/${taskId}`);
};

